'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _modules = require('redux/modules/modules');

var _reactRouter = require('react-router');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module2Res3 = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}, { changeItem: _modules.changeItem }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module2Res3, _Component);

  function Module2Res3() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module2Res3);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module2Res3.__proto__ || (0, _getPrototypeOf2.default)(Module2Res3)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currPage: 0,
      title: 'Establishing rules',
      types: {
        app: 0,
        extra: 1,
        activity: 2
      }
    }, _this.handleClickNext = function () {
      var obj = _this.state;
      obj.currPage = _this.state.currPage + 1;
      _this.setState(obj);
    }, _this.handleClickPrev = function () {
      var obj = _this.state;
      obj.currPage = _this.state.currPage - 1;
      _this.setState(obj);
    }, _this.handleOnClick = function (module, modtype, item, page, event) {
      console.log(event);
      _this.props.changeItem(module, modtype, item, page);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /**
   *  User clicks on Next
   *  Increments the Page number and changes panel
   */


  /**
   *  User clicks on Previous
   *  Decrements the Page number and changes panel
   */


  /*
   * Quick link at the top to change the current page
   * to the selected page
   */
  /* handleOnClick = (item, event) => {
    event.preventDefault();
    console.log(event);
    console.log('CLICKED ' + item);
    const obj = this.state;
    obj.currPage = item;
    this.setState(obj);
  } */

  // used to navigate to a resource item


  (0, _createClass3.default)(Module2Res3, [{
    key: 'render',
    value: function render() {
      var styles = require('../Resources.scss');
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 12, lg: 12, sm: 12, xs: 12 },
          _react2.default.createElement(
            'div',
            { className: styles.activityPanel },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              _react2.default.createElement(
                'h3',
                null,
                'Module 2'
              ),
              _react2.default.createElement(
                'h2',
                null,
                this.state.title
              )
            ),
            _react2.default.createElement(
              'h4',
              null,
              'Why do we need rules'
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Rules can clarify expectations and help kids feel more secure'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Without clear rules, kids may try to test the boundaries eg. when children ask for unhealthy food and you say no, they may begin to cry or scream. We understand that this can be hard for parents. Try to stay calm and be consistent with saying no.'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'When saying no, try to explain to them why you are saying no. For example, explain to children some foods are only eaten on special occasions',
                  _react2.default.createElement('br', null),
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { to: '/module1', onClick: this.handleOnClick.bind(this, 1, this.state.types.extra, 4, 0) },
                    '(see non-core foods from Module 1)'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'h4',
              null,
              'Involving children in making rules'
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Before you set any rules, explain to your child why they are important'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'It is better to have a few (three or four) very clear rules rather than a long list'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Involving your child in developing rules can help them learn the values behind the rules. This also makes it more likely that they will follow them'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'It is important that your rules are appropriate for the age and stage of development of your child'
                )
              )
            ),
            _react2.default.createElement(
              'h4',
              null,
              'Write down and display'
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'It is a good idea to draw or write down the rules as a family so everyone understands them'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'It is also useful to display them somewhere in the house eg. on the fridge, a wall or inside cupboard door. This lets all adults in the house (including visiting grandparents and extended family) know exactly what the family rules are around eating'
                )
              )
            ),
            _react2.default.createElement(
              'h4',
              null,
              'Wording'
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'When you write down or draw the rules, try to be as specific as possible. This will help everyone to be consistent.'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'As much as you can, present the rules in a positive way and focus on the behaviour that is expected, rather than the unacceptable behaviour'
                )
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Table,
              { bordered: true, striped: true, responsive: true },
              _react2.default.createElement(
                'thead',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'th',
                    null,
                    'Positive way'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Negative way'
                  )
                )
              ),
              _react2.default.createElement(
                'tbody',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    '"Everyone eats at the table'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    '"Eating in front of the TV is not allowed in the house'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    '"If you are hungry, you can choose between a piece of carrot with peanut butter or a piece of toast with cheese and tomato"'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'No, you can\'t have a cookie'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'h4',
              null,
              'Revising rules'
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'It is best not to change rules too often. Being consistent is important for kids to understand what behaviour is acceptable and what is not.'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'As your situation changes (eg. starting school, having another baby) and as children get older, it is necessary to review and revise the rules. Again, it is important to involve children in the process.'
              )
            ),
            _react2.default.createElement(
              'h4',
              null,
              'Keep to the rules'
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Rules only work with children if you stick to them. Another important part of establishing a rule is deciding what happens when the rule is broken. It is critical that whatever the consequence, it is applied consistently.'
              )
            ),
            _react2.default.createElement('div', { className: styles.spacer40 })
          )
        )
      );
    }
  }]);
  return Module2Res3;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  module: _propTypes2.default.number,
  modtype: _propTypes2.default.number,
  item: _propTypes2.default.number,
  page: _propTypes2.default.number,
  changeItem: _propTypes2.default.func.isRequired
}, _temp2)) || _class);
exports.default = Module2Res3;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/2/Res3.js
// module id = 1240
// module chunks = 0